export default __webpack_public_path__ + "static/media/image_4.0d33b97a.webp";